import { render } from "./kartonSucheTeaser.vue?vue&type=template&id=695c0a27"
import script from "./kartonSucheTeaser.vue?vue&type=script&lang=js"
export * from "./kartonSucheTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__